import React from 'react';
import { format, isValid } from 'date-fns';
import TimeService from 'general/js/services/time-service';

class LiveTextServerTime extends React.Component {
    constructor(props) {
        super(props);
        this.intervalId = null;
        this.state = {
            time: null
        };
    }

    componentDidMount() {
        window.addEventListener("visibilitychange", this.visibilityChange);
        this.getCurrentTime();
    }

    getCurrentTime = () => {
        TimeService.getTime().then((timeString) => {
            const serverTime = new Date(timeString);
            const utcTimeString = timeString
                .replace(/-/g, '/')
                .replace('T', ' ')
                .replace(/\.\d*/, '');
            const utcTime = new Date(utcTimeString);

            this.setState({ time: isValid(utcTime) ? utcTime : serverTime });
            this.enableAutoUpdate();
        });
    }

    visibilityChange = () => {
            if (document.hidden) {
                window.clearInterval(this.intervalId);
            }
            else {
                this.getCurrentTime();
            }
    }

    componentWillUnmount() {
        window.clearInterval(this.intervalId);
        window.removeEventListener("visibilityChange", this.visibilityChange);
    }

    enableAutoUpdate = () => {
        this.intervalId = setInterval(() => {
            if (this.state.time !== null) {
                this.setState({ time: new Date(this.state.time.getTime() + 1000) });
            }
        }, 1000);
    }

    render() {
        return (
            <div>
                <b>{format(this.state.time, 'h:mm a')}</b>
                &nbsp;
                <span>{format(this.state.time, 'ddd D MMM')}</span>
            </div>
        );
    }
}

export default LiveTextServerTime;
